import { makeStyles } from "@material-ui/core";

export default makeStyles(
  (theme) => ({
    title: {
      marginBottom: 10,
      fontSize: theme.typography.pxToRem(18),
      fontWeight: 500,
      [theme.breakpoints.up("tablet")]: {
        fontSize: theme.typography.pxToRem(24),
      },
    },
  }),
  { name: "Title" },
);
